/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { NewLanguageService } from './../../../dataservices/new-language/new-language.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { GetService } from '../../../dataservices/get.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Event Session Modal Component
 */
@Component({
  selector: 'app-event-session-modal',
  templateUrl: './event-session-modal.component.html',
  styleUrls: ['./event-session-modal.component.scss']
})
export class EventSessionModalComponent implements OnInit, OnChanges, OnDestroy {

  @Input() data;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public finished: any;
  public dayList = [];
  public SessionObj = [];
  public display_rec = 0;
  public selected_index = 0;
  public total_session = 0;
  public action = '';
  public session_media_list = [];
  public is_show_session_media = false;
  public session_id_for_media = 0;
  public isSkpModalShown = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public vaultObj: any;
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    private getApiService: GetService,
    public fcs: FunCollectionService,
    public mls: NewLanguageService,
    public Dss: DataStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private jwtSer: JwtDecodeService,
    private masterService: MasterserviceService,
    public postSer: PostApiService
  ) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.dayList = this.data.data[0].data;
    this.selected_index = this.data.data[0].index;
    this.action = this.data.data[0].action;
    this.display_rec = this.data.data[0].data[this.selected_index].program_id;
    this.eventsessionList(this.display_rec);
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    this.session_media_list = [];
  }

  /**
   * event session List
   */
  eventsessionList(pro_id): void {
    this.session_media_list = [];
    this.is_show_session_media = false;
    this.selected_index = this.dayList.findIndex(obj => obj.program_id == pro_id);
    this.finished = true;
    this.SessionObj = [];
    this.total_session = 0;
    this.subscriptions.add(this.getApiService.getSessionList(pro_id).subscribe(resData => {

      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.finished = false;
          this.SessionObj = data.data.session_list;
          this.total_session = data.data.total_session;
        } else if (data.status == 0) {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }


  /**
   * navigate To Detail
   */
  navigateToDetail(id): boolean {
    if (this.action == 'session_media') {
      this.session_id_for_media = id;
      this.is_show_session_media = true;
      this.getSessionMediaList();
      return;
    }
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.goback();
    this.router.navigateByUrl('event/session-details/' + id);

  }

  /**
   * go back
   */
  goback(): void {
    const displayObj = {
      isShow: false,
      display_section: '',
      data: []
    };
    this.Dss.suggAssList = [];
    this.Dss.selected_suggAssList = [];

    this.masterService.showWebModal.next(displayObj);
  }

  /**
   * get Session Media List
   */
  getSessionMediaList(): void {
    this.subscriptions.add(this.getApiService.getEventMedialist(21, this.session_id_for_media).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.session_media_list = data['data'].media_list;
        } else {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * event certificate
   */
  eventcertificate(programid): void {
    this.subscriptions.add(this.getApiService.viewEventCertificate(programid).subscribe(resData => {

      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {

          this.vaultObj = data.data.vault_list;
          // console.log(this.vaultObj)

          this.isSkpModalShown = true;
        }
      });
    }));
  }

  /**
   * reset Skp Modal
   */
  resetSkpModal(): void {
    this.isSkpModalShown = false;
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
